import { useEffect, useState } from "react";

import Link from "next/link";

import { Button } from "antd";
import useTranslation from "next-translate/useTranslation";
import PropTypes from "prop-types";

import StaticIntlTranslator from "shared/components/atoms/StaticIntlTranslator";
import { useGlobalContext } from "shared/utils/hooks/useGlobalContext";
import staticIntlTranslatorToString from "shared/utils/staticIntlTranslatorToString";

import BundleFeatures from "./components/BundleFeatures";
import { BundleCardContainer } from "./styles";

const BundleCard = ({ bundle, handlePurchase }) => {
  const { lang } = useTranslation();

  const { state, setState } = useGlobalContext();

  const themeBuyButtonsOption =
    state.tenancy?.settings?.["advanced-theme"]?.themeBuyButtonsOption;

  const themeBuyButtonsColor =
    state.tenancy?.settings?.["advanced-theme"]?.themeBuyButtonsColor;

  const [publishedPlans, setPublishedPlans] = useState(null);

  const handleOpenPurchaseOptions = () => {
    setState((prev) => ({
      ...prev,
      enrollments: {
        paymentOptions: {
          entity: bundle,
          context: "product_bundle",
          handlePurchase,
          show: true,
        },
      },
    }));
  };

  useEffect(() => {
    if (bundle?.plans?.length > 0) {
      const activePlans = bundle.plans.filter(
        (plan) => plan.status === "published",
      );
      setPublishedPlans(activePlans);
    }
  }, [bundle]);

  return (
    <BundleCardContainer
      className="container"
      customButtonColor={themeBuyButtonsColor}
      themeBuyButtonsOption={themeBuyButtonsOption}
    >
      <Link href={`/bundles/${bundle.slug}`} data-testid="next-link">
        <h3 className="bundleCardTitle">
          {staticIntlTranslatorToString(bundle.title, lang)}
        </h3>
      </Link>

      <div className="plan-card-body">
        {!state.isMobileAppClient &&
          (publishedPlans?.length > 0 ? (
            <>
              <span>
                <StaticIntlTranslator id="common:signBy" />
              </span>
              <h2>{bundle.lowest_price}</h2>
            </>
          ) : (
            <h2>{bundle.price}</h2>
          ))}

        {bundle?.features?.length > 0 && (
          <BundleFeatures features={bundle.features} />
        )}

        {bundle.access_type === "private" ? (
          <h4 className="private-warn">
            <StaticIntlTranslator id="common:bundleTemporarilyUnvailable" />
          </h4>
        ) : (
          <>
            {publishedPlans?.length > 0 ? (
              <>
                {publishedPlans.length === 1 && !bundle?.individual_sale ? (
                  <Button
                    className="buy-btn"
                    onClick={() =>
                      handlePurchase("plan", "plan_id", publishedPlans[0])
                    }
                  >
                    <StaticIntlTranslator id="common:subscribeNow" />
                  </Button>
                ) : (
                  <>
                    <Button
                      className="buy-btn"
                      onClick={handleOpenPurchaseOptions}
                    >
                      {bundle?.individual_sale ? (
                        <StaticIntlTranslator id="common:buyOrSubscribe" />
                      ) : (
                        <StaticIntlTranslator id="common:subscribeNow" />
                      )}
                    </Button>
                  </>
                )}
              </>
            ) : (
              <Button
                type="primary"
                className="buy-btn"
                onClick={() => {
                  handlePurchase("product-bundle", "product_bundle_id", bundle);
                }}
              >
                <StaticIntlTranslator id="common:buyNow" />
              </Button>
            )}
          </>
        )}
      </div>
    </BundleCardContainer>
  );
};

BundleCard.propTypes = {
  bundle: PropTypes.object.isRequired,
  handlePurchase: PropTypes.func.isRequired,
};

export default BundleCard;
